export const addGuestId = (user) => {
  const guestId = localStorage.getItem('guestId');
  if (guestId) {
    user.guestId = guestId;
  }
  return user;
};
